var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.enabled
    ? _c("SelectPicker", {
        staticClass: "username navbar-username navbar-dropdown",
        attrs: {
          "data-class": "btn-link navbar-brand navbar-dropdown-button",
          "data-width": "auto",
          "data-menu-width": "auto",
          right: "",
          hideEmpty: "",
          placeholder: "Not logged in",
          allowUnknownValues: "",
          disabled: !_vm.canLogin,
          value: _vm.username,
          options: _vm.options,
        },
        on: { input: _vm.handle },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }